'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
defineWellKnownSymbol('matchAll');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.match-all.js
// module id = 271
// module chunks = 0